import Vue from "vue";
import eleicaonetService from "@/services/eleicaonet";

export const coresMixin = {
  data() {
    return {
      cores: {
        eleicaonet: {
          50: "#eff6ff",
          100: "#dbeafe",
          200: "#bfdbfe",
          300: "#93c5fd",
          400: "#60a5fa",
          500: "#3b82f6",
          600: "#2563eb",
          700: "#1d4ed8",
          800: "#1e40af",
          900: "#1e3a8a",
          950: "#172554",
        },
        eleicaonet2: {
          50: "#ecfdf5",
          100: "#d1fae5",
          200: "#a7f3d0",
          300: "#6ee7b7",
          400: "#34d399",
          500: "#10b981",
          600: "#059669",
          700: "#047857",
          800: "#065f46",
          900: "#064e3b",
          950: "#022c22",
        },
      },
      coresLoading: false,
      coresError: null,
    };
  },
  methods: {
    async carregarCores() {
      this.coresLoading = true;
      this.coresError = null;

      try {
        const response = await eleicaonetService.loadCores();
        this.cores = response.data;

        // Aplicar as cores como variáveis CSS
        this.aplicarCoresCSS(this.cores);
      } catch (err) {
        console.error("Erro ao carregar cores:", err);
        this.coresError = err.message;
      } finally {
        this.coresLoading = false;
      }
    },

    aplicarCoresCSS(coresData) {
      const root = document.documentElement;

      // Aplicar cores do eleicaonet
      Object.keys(coresData.eleicaonet).forEach((key) => {
        root.style.setProperty(
          `--eleicaonet-${key}`,
          coresData.eleicaonet[key]
        );
      });

      // Aplicar cores do eleicaonet2
      Object.keys(coresData.eleicaonet2).forEach((key) => {
        root.style.setProperty(
          `--eleicaonet2-${key}`,
          coresData.eleicaonet2[key]
        );
      });

      // Expor cores globalmente no protótipo para acesso direto em componentes
      Vue.prototype.$hotsiteCores = coresData;

      // Controle do switch de alternância de cores nos Diretórios
      if (
        coresData.elementos &&
        coresData.elementos.candidatos &&
        (coresData.elementos.candidatos.alternarCoresDiretorios === true ||
          coresData.elementos.candidatos.alternarCoresDiretorios === "true")
      ) {
        root.classList.add("alternar-diretorios");
        root.style.setProperty(
          "--custom-candidatos-alternarCoresDiretorios",
          "1"
        );
      } else {
        root.classList.remove("alternar-diretorios");
        root.style.setProperty(
          "--custom-candidatos-alternarCoresDiretorios",
          "0"
        );
      }

      // Aplicar cores granulares de elementos (se definidas)
      if (coresData.elementos && typeof coresData.elementos === "object") {
        Object.keys(coresData.elementos).forEach((secao) => {
          const props = coresData.elementos[secao];
          if (props && typeof props === "object") {
            Object.keys(props).forEach((prop) => {
              const val = props[prop];
              const varName = `--custom-${secao}-${prop}`;
              if (typeof val === "boolean") {
                root.style.setProperty(varName, val ? "1" : "0");
              } else if (val && typeof val === "string" && val.trim() !== "") {
                root.style.setProperty(varName, val.trim());
              } else {
                root.style.removeProperty(varName);
              }
            });
          }
        });
      }
    },
  },
  async mounted() {
    await this.carregarCores();
  },
};
